import { CollectionEntity } from "@busy-human/gearbox";
import { CONSTANTS } from "../constants.js";
export var Userspaces;
(function (Userspaces) {
    function Defaults() {
        return {
            name: {
                fullName: "",
                firstName: "",
                lastName: "",
            },
            email: "",
            phone: "",
            postalCode: "",
            currentBalance: 0,
            leadOrigin: CONSTANTS.LEAD_ORIGIN.Other,
            productInterest: CONSTANTS.PRODUCT_INTEREST.Other,
            discountQualifier: CONSTANTS.DISCOUNT_QUALIFIER.None,
            status: CONSTANTS.STATUS.New,
            notes: "",
        };
    }
    Userspaces.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Defaults();
        }
    }
    Userspaces.CollectionClass = CollectionClass;
    Userspaces.Collection = new CollectionClass({ path: "/Userspaces" });
})(Userspaces || (Userspaces = {}));
//# sourceMappingURL=index.js.map